import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Media} from "storyboard-renderer";
import {UploadMediaComponent} from "./upload-media/upload-media.component";

@Component({
  selector: 'app-media-library',
  templateUrl: './media-library.component.html',
  styleUrls: ['./media-library.component.scss']
})

export class MediaLibraryComponent implements OnInit {

  activeMenu: String = 'upload';
  @Input() userId = null;

  @ViewChild('uploadMedia')
  uploadMediaComponent: UploadMediaComponent;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
  }
  startUpload() {
    this.uploadMediaComponent.startUpload();
  }

  isAllowToUpload() {
    return this.uploadMediaComponent && this.uploadMediaComponent.files.length;
  }

  changeMenu(name: String) {
    this.activeMenu = name;
  }

  onSelectMedia(media: Media) {
    this.activeModal.close(media);
  }

  onUploadDone(uploadedFiles) {
    if (uploadedFiles.length > 1) {
      this.changeMenu('browse');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/media-library/media-library.component.ts